// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cPeLu","title":"styles_title__7KoQG","content":"styles_content__W7T3b"};